// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"177":"406abd78","253":"55cce929","525":"affe14df","608":"f997f48b","657":"a2572ad1","907":"4c7f25bb","932":"1440ac8c","962":"b55ef706"}[chunkId] + ".chunk.js";
};